import { render, staticRenderFns } from "./SkeletonLoaderCard.vue?vue&type=template&id=4338d5e1"
import script from "./SkeletonLoaderCard.vue?vue&type=script&lang=js"
export * from "./SkeletonLoaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports